var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("path", { d: "M26.618 25.97h1.385v-9.23c0-.94 1.116-1.704 1.996-1.704.881 0 2.004.763 2.004 1.705v9.23h1.378c1.258 0 2.224-.147 2.521.526.337.758-.215 1.12-1.395 2.386l-3.38 3.618a1.523 1.523 0 01-2.255 0l-3.38-3.618c-1.187-1.274-1.73-1.668-1.394-2.394.298-.646 1.271-.518 2.52-.518zM21.382 22.029h-1.377v9.243c0 .942-1.123 1.706-2.004 1.706s-2-.764-2-1.706v-9.243H14.62c-1.259 0-2.225.148-2.523-.527-.336-.757.217-1.118 1.396-2.384l3.38-3.619a1.522 1.522 0 012.255 0l3.38 3.62c1.187 1.273 1.73 1.667 1.394 2.392-.299.647-1.27.518-2.52.518z" }))));
});
